module.exports = __webpack_public_path__ + "img/features_7.a26eb9b5.png";